import styles from "./ImpressionKarte.module.css";

function ImpressionKarte({ title, body, image }) {
  return (
    <div className={styles.impressionKarteContainer}>
      <img
        className={styles.impressionImage}
        src={
          image ||
          "https://gagostortillas.de/cdn/shop/files/Foodtruck_mit_Logo.png?v=1716660984&width=1500"
        }
        alt="default"
      />
      <p className={styles.impressionTitle}>{title}</p>
      <p className={styles.impressionDescription}>{body}</p>
    </div>
  );
}

export default ImpressionKarte;
